import { render } from "./Correction.vue?vue&type=template&id=2c97d486&scoped=true"
import script from "./Correction.vue?vue&type=script&lang=js"
export * from "./Correction.vue?vue&type=script&lang=js"

import "./Correction.vue?vue&type=style&index=0&id=2c97d486&scoped=true&lang=css"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c97d486"]])

export default __exports__